/**
 * Feature flags.
 *
 * FILE_UPLOADS_ENABLED — attachments currently go to local disk via
 * backend/services/fileStorage.js, which doesn't survive a container redeploy.
 * Uploads stay switched off until that seam is pointed at S3.
 *
 * Everything else stays live and unchanged: the Files tab, listing files,
 * opening and deleting existing ones, and the activity feed's file events.
 * Only the two entry points that create new files are gated — the "Upload file"
 * button on the Files tab and the paperclip in the activity composer.
 *
 * To turn uploads on once S3 is configured, flip this to true. Nothing else
 * needs to change; the upload handlers and endpoints are already wired.
 *
 * Note: this gates the UI only. The POST /files endpoints remain open, so if
 * you want uploads blocked server-side too, that needs a guard in
 * backend/middlewares/attachmentUpload.js as well.
 */
export const FILE_UPLOADS_ENABLED = false;

/** Shown as the tooltip on the disabled upload controls. */
export const UPLOADS_DISABLED_MESSAGE =
  "File uploads are disabled until cloud storage is set up";
